const LOCAL_STORAGE_KEY = 'ADD_LINE_ITEMS_DIALOG_SETTINGS';

export default LOCAL_STORAGE_KEY;
